export default __webpack_public_path__ + "static/media/sam.fce6f5d8.png";